import { Notification, ValidatedInput, useAnalyticsPageViewTracker } from '@cp-shared-15/frontend-ui';
import { Fieldset, Layout } from '@vwfs-bronson/bronson-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const MarketingPreferencesEmail: React.FC = () => {
    const { t } = useTranslation('marketing-preferences-email');
    useAnalyticsPageViewTracker('marketingAgreementNoEmail');

    return (
        <Fieldset>
            <Fieldset.Row>
                <Layout>
                    <Layout.Item>
                        <Notification headline={t('notification.headline')} className={'u-mb-small'}>
                            {t('notification.text')}
                            <Fieldset.Row>
                                <ValidatedInput
                                    label={t('email-address')}
                                    isMandatory
                                    required
                                    name="emailAddress"
                                    testId="email-address"
                                    type="email"
                                />
                            </Fieldset.Row>
                        </Notification>
                    </Layout.Item>
                </Layout>
            </Fieldset.Row>
        </Fieldset>
    );
};
